import { Button } from '@/components/ui/button'

const Pagination = ({ page, pagesCount, setPage }) => {
  if (pagesCount < 1) {
    return null
  }

  return (
    <div className='flex justify-between items-center my-5'>
      <p className='text-sm text-muted-foreground'>
        Page {page} of {pagesCount}
      </p>

      <div className='flex items-center space-x-2'>
        <Button
          variant='outline'
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
        >
          Previous
        </Button>

        <Button
          variant='outline'
          onClick={() => setPage(page + 1)}
          disabled={page === pagesCount}
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default Pagination
